import { useState } from 'react';
import FeedbackModalView from './FeedbackModal.View';
import { FeedbackModalProps } from './types';
import { trackActionEvent } from 'lib/analytics';
import { useAuth0 } from '@auth0/auth0-react';
import { useBrandStore } from 'stores';
import { useToaster } from '@innovationdepartment/proxima-ui';

const MAX_CHAR_LENGTH = 150;

const FeedbackModal = (props: FeedbackModalProps) => {
  const { user } = useAuth0();
  const { brand } = useBrandStore();
  const { showToaster } = useToaster();
  const { aiResponse, originalQuestion, onClose, open } = props;
  const [feedback, setFeedback] = useState('');

  const onCloseModal = () => {
    onClose();
    setTimeout(() => setFeedback(''), 250);
  };

  const onSubmit = async () => {
    if (feedback.trim().length > MAX_CHAR_LENGTH) {
      showToaster({
        message: `Feedback must be less than ${MAX_CHAR_LENGTH} characters.`,
        variant: 'error',
      });
      return;
    }

    const cleanMessage = (message: string) =>
      message
        .replace(/<[^>]*>/g, '')
        /* Replace multiple newlines or carriage returns with a single space */
        .replace(/[\r\n]+/g, ' ')
        /* Replace multiple spaces/tabs with a single space */
        .replace(/\s+/g, ' ')
        /* Trim whitespace from both ends */
        .trim();

    await trackActionEvent({
      action: 'AI feedback submitted',
      userId: user?.sub!,
      brandId: brand?.brandId,
      location: 'FeedbackModal',
      data: {
        brandName: brand?.name,
        feedback: cleanMessage(feedback),
        aiResponse: cleanMessage(aiResponse),
        originalQuestion: cleanMessage(originalQuestion),
      },
      fromUserId: user?.sub,
    });

    showToaster({
      message: 'Thank you for your feedback!',
      variant: 'success',
    });
    onCloseModal();
  };

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setFeedback(newValue);
  };

  return (
    <FeedbackModalView
      onClose={onCloseModal}
      onSubmit={onSubmit}
      onChange={onChange}
      value={feedback}
      open={open}
      maxCharLength={MAX_CHAR_LENGTH}
    />
  );
};

export default FeedbackModal;
